import { IconDropDownButton } from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/IconDropDownButton';
import { useGlobalForms } from '@lmt/unicorn-shared/app/components/global-forms/useGlobalForms';
import { pages } from '@lmt/unicorn-shared/app/constants/sharedRoutes';
import { useTabs } from '@lmt/unicorn-shared/app/features/navigation/operations';

import AddContentIcon from '@lmt/unicorn-shared/app/icons/add-content.svg?react';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React, { useCallback } from 'react';

import styles from './ContentButton.module.scss';

interface AddDocumentButtonProps {
  patientId: number;
  dataBlockId: number;
  visitId: number | undefined;
}

interface MatchParams {
  tabId: string;
  patientId: string;
  caseId: string;
}

export const AddDocumentButton: React.FC<AddDocumentButtonProps> = (props) => {
  const forms = useGlobalForms();
  const tabs = useTabs();
  const i18next = useScopedTranslation('patients.documents');
  const match = pages.patientCases.useMatch();

  const openDocumentCreation = useCallback(() => {
    if (!match) {
      return;
    }
    const caseId = match?.params?.caseId;
    const link = pages.createPatientDocument.link(
      {
        patientId: props.patientId,
      },
      { caseId, dataBlockId: props.dataBlockId, visitId: props.visitId },
    );
    tabs.openTab(link);
  }, []);

  const addDocumentOptions = [
    {
      value: 'create',
      displayValue: i18next.t('add_button_create'),
      onClick: openDocumentCreation,
    },
    {
      value: 'import',
      displayValue: i18next.t('add_button_import'),
      onClick: () => forms.importDocument(props.dataBlockId),
    },
  ];

  return (
    <IconDropDownButton
      iconComponent={<AddContentIcon className={styles.addContentIcon} />}
      options={addDocumentOptions}
      optionListClassName={styles.optionListContainer}
    />
  );
};
